import React, { useEffect } from "react";
import { useState } from "react";
import { Button } from "@mui/material";
import { fetchRemitterById, registerRemitter } from "../../api/remitterApi";
import Main from "../Main";
import AppBreadcrumbs from "../../components/ui/AppBreadcrumbs";
import useBankVerification from "../../hooks/useBankVerification";

import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { dmtBanks } from "../../json-data/dmtbanklist";
import { useNotify } from "../../context/NotifyContext";
const AddBeneficiaryBank = () => {
  const [holderName, setHolderName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [confirmAccount, setConfirmAccount] = useState("");
  const [ifsc, setIfsc] = useState("");
  const { notify } = useNotify();

  const [remarks, setRemarks] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
const [loading,setLoading] = useState(false)
  const initialPhone = searchParams.get("phone") || "";
const [mobile,setMobile] = useState(initialPhone)
 const {id} = useParams()
  const [bankName,setBankName] =useState('')
  const [allBanks, setAllBanks] = useState([]);
const [bankId, setBankId] = useState("");
const [beneficiaryId, setBeneficiaryId] = useState("");
const navigate = useNavigate()
const {
  verify: verifyBankAccount,
  loading: bankVerificationLoading,
  result: bankVerification,
  verificationRequired,
  policyLoading: bankVerificationPolicyLoading,
  statusLoading: bankVerificationStatusLoading,
  alreadyVerified: bankAlreadyVerified,
  pending: bankVerificationPending,
} = useBankVerification({
  sourceType: "BENEFICIARY",
  sourceId: beneficiaryId,
  bankId,
  onVerified: (result) => {
    if (result.beneficiaryName) setHolderName(result.beneficiaryName);
  },
});


const fetch_remitter = async () => {
  if (!id) return notify("Invalid Remitter", "error");

  try {
    setLoading(true);
    const res = await fetchRemitterById(id);

    if (res?.success) {
      setMobile(res?.data?.remitter?.mobile);
    } else {
      notify(res?.message || "Failed to fetch remitter", "error");
    }
  } catch {
    notify("Server Error", "error");
  } finally {
    setLoading(false);
  }
};

  useEffect(()=>{
fetch_remitter()
  },[id])


useEffect(() => {
  if (dmtBanks?.length) {
    setAllBanks(dmtBanks);
  }
}, [dmtBanks]);


const handleSubmit = async (e) => {
  e.preventDefault();

  if (beneficiaryId) {
    const verification = await verifyBankAccount();
    if (verification?.verified || !verificationRequired) {
      navigate(`/money?phone=${mobile}`);
    }
    return;
  }

  if (!holderName || !accountNumber || !confirmAccount || !ifsc || !mobile) {
    return notify("Please fill all required fields", "error");
  }

  if (accountNumber !== confirmAccount) {
    return notify("Account numbers must match", "error");
  }

  if (!/^\d{9,18}$/.test(accountNumber)) {
    return notify("Account number must be 9-18 digits", "error");
  }

  if (!/^[A-Z]{4}0[A-Z0-9]{6}$/i.test(ifsc.trim())) {
    return notify("Enter a valid 11-character IFSC code", "error");
  }

    if (!bankId) {
    return notify("Select Any Bank Name", "error");
  }

  const payload = {
    mobile,
    bankId:bankId,
    benename: holderName,
    accno: accountNumber,
    ifsccode: ifsc,
    remarks,
    branch: null,
    bankName,
  };

  try {
    setLoading(true);
    const res = await registerRemitter(payload);

    if (res?.success) {
      const createdId = res?.data?._id || res?.data?.beneficiary?._id;
      if (!createdId) {
        throw new Error("Beneficiary was saved but its ID was not returned");
      }
      setBeneficiaryId(String(createdId));
      if (verificationRequired) {
        const verification = await verifyBankAccount({
          sourceIdOverride: String(createdId),
        });
        if (!verification?.verified) return;
      }
      notify(res?.message || "Beneficiary added successfully", "success");
      navigate(`/money?phone=${mobile}`);

      // reset
      setHolderName("");
      setAccountNumber("");
      setConfirmAccount("");
      setIfsc("");
      setRemarks("");
      setBankName("");
    } else {
      notify(res?.message || "Failed to add beneficiary", "error");
    }
  } catch {
    // notify("Server Error", "error");
  } finally {
    setLoading(false);
  }
};





  return (
        <Main showRightPanel={false}>
      <div className="px-0 md:px-4 mt-4 font-[Poppins]">
        <AppBreadcrumbs
          items={[
            { label: "Dashboard", to: "/" },
            { label: "MATM Module" },
            { label: "Other Options" },
            { label: "Settlement History" },
          ]}
        />
      <div className="border border-gray-100 shadow-xl rounded-xl p-4 md:p-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-4 gap-3">
          <h2 className="text-xl md:text-2xl font-semibold">
            Beneficiary Account Details
          </h2>
          <button className="bg-[#0073b1] text-white px-5 py-2 rounded w-full md:w-auto text-sm md:text-base">
            BANK DETAILS
          </button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          <div className="flex flex-col">
            <label className="text-sm font-medium mb-1">
              ACCOUNT HOLDER NAME <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={holderName}
              name="holdername"
              onChange={(e)=>setHolderName(e.target.value)}
              placeholder="Account Holder Name"
              className="border px-3 py-2 rounded-md text-sm"
            />
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-medium mb-1">
              SELECT OR SEARCH BANK NAME <span className="text-red-500">*</span>
            </label>
       <select
  className="border px-3 py-2 rounded-md text-sm w-full"
  value={bankId}
  onChange={(e) => setBankId(e.target.value)}
>
  <option value="" disabled>
    Select Bank Name
  </option>

  {allBanks.map((bank) => (
    <option key={bank.BankId} value={bank.BankId}>
      {bank.BankName}
    </option>
  ))}
</select>

          </div>
<div className="flex flex-col">
  <label className="text-sm font-medium mb-1">
    ACCOUNT NUMBER <span className="text-red-500">*</span>
  </label>

  <input
    type="text"
    name="accountNumber"
    value={accountNumber}
    placeholder="Account Number"
    inputMode="numeric"
    pattern="[0-9]*"
    maxLength={20}
    onChange={(e) => {
      const value = e.target.value.replace(/\D/g, "");
      setAccountNumber(value);
    }}
    className="border px-3 py-2 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
  />

  {/* Min length validation */}
  {accountNumber.length > 0 && accountNumber.length < 5 && (
    <p className="text-red-500 text-xs mt-1">Minimum 5 digits required</p>
  )}
</div>

<div className="flex flex-col">
  <label className="text-sm font-medium mb-1">
    CONFIRM ACCOUNT NUMBER <span className="text-red-500">*</span>
  </label>

  <input
    type="text"
    name="confirmAccount"
    value={confirmAccount}
    placeholder="Confirm Account Number"
    inputMode="numeric"
    pattern="[0-9]*"
    onChange={(e) => {
      const value = e.target.value.replace(/\D/g, "");
      setConfirmAccount(value);
    }}
    className="border px-3 py-2 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
  />
</div>
          <div className="flex flex-col">
            <label className="text-sm font-medium mb-1">
              IFSC CODE <span className="text-red-500">*</span>
            </label>
            <div className="flex  flex-row gap-2">
              <input
                type="text"
                value={ifsc}
                name="ifsc"
                    maxLength={11}
                onChange={(e) => setIfsc(e.target.value.toUpperCase())}
                placeholder="Enter IFSC Code SBIN0000001"
                className="border px-3 py-2 rounded-md flex-1 text-sm"
              />
            </div>
            {verificationRequired && beneficiaryId && !bankAlreadyVerified && (
              <button
                type="button"
                onClick={verifyBankAccount}
                disabled={
                  loading ||
                  bankVerificationLoading ||
                  bankVerificationPolicyLoading ||
                  bankVerificationStatusLoading ||
                  bankVerificationPending ||
                  bankVerification?.policy?.providerEnabled === false ||
                  holderName.trim().length < 3 ||
                  !/^[6-9]\d{9}$/.test(mobile) ||
                  !/^\d{9,18}$/.test(accountNumber) ||
                  !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc.trim().toUpperCase())
                }
                className="ds-btn ds-btn-primary mt-2 text-sm"
              >
                {bankVerificationLoading
                  ? "Checking…"
                  : bankVerificationPending
                    ? "Verification pending"
                    : "Verify bank account"}
              </button>
            )}
            <p className="mt-1 text-xs text-[var(--text-muted)]" role="status">
              {bankVerification?.verificationBypassed
                ? "Verification Bypassed"
                : bankAlreadyVerified
                  ? "Bank Verified"
                  : bankVerificationPending
                    ? "Verification Pending"
                    : bankVerification?.verificationStatus === "FAILED"
                      ? "Verification Failed"
                      : "Verify Bank"}
              {verificationRequired &&
                bankVerification?.policy?.pennyDropCharge?.enabled &&
                ` Verification charge: ₹${bankVerification.policy.pennyDropCharge.amount}.`}
            </p>
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-medium mb-1">
              MOBILE NUMBER <span className="text-red-500">*</span>
            </label>
         <input
  type="text"
  name="mobile"
  disabled
  value={mobile}
  onChange={(e) => {
    const val = e.target.value;
    if (/^[0-9+]*$/.test(val)) {
      setMobile(val);
    }
  }}
  placeholder="Enter Mobile Number"
  className="border px-3 py-2 rounded-md text-sm"
  maxLength={15}  // Optional but useful
/>
          </div>
          <div className="flex flex-col md:col-span-2">
            <label className="text-sm font-medium mb-1">
              REMARKS <span className="text-red-500">*</span>
            </label>
            <textarea
            value={remarks}
            onChange={(e)=>setRemarks(e.target.value)}
              placeholder="Your Remarks here..."
              className="border px-3 py-2 rounded-md h-24 text-sm"
            />
          </div>
        </div>
        <div className="flex whitespace-nowrap justify-center gap-4 mt-5">
          <button className="bg-[#16A34A26] text-[#16A34A] px-12 py-2 rounded-md font-medium text-sm md:text-base w-full sm:w-auto">
            Cancel
          </button>
                        <Button
                   onClick={handleSubmit}
                    loading={loading}
                    loadingPosition="end"
                    variant="contained"
                      type="button"
           disabled={loading || bankVerificationPolicyLoading || bankVerificationPending}
           className="bg-[#02026E26] text-[#02026E] px-8 py-2 rounded-md font-medium text-sm md:text-base w-full sm:w-auto"
                  >
                       {beneficiaryId ? "Verify & Continue" : "Add & Verify"}
                  </Button>
        </div>
      </div>
    </div>
      </Main>
  );
};
export default AddBeneficiaryBank;